import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoginUser } from "../Redux/Auth/Action";
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
} from "@chakra-ui/react";

import { Navigate } from "react-router-dom";
import { Toast } from "../Componants/Toast";

export const Login = () => {
  const { isAuth, token } = useSelector((store) => store.authReducer);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    const obj = { email, password };
    dispatch(LoginUser(obj));
  };

  // useEffect(() => {
  //   // Check if authentication state is stored in localStorage
  //   const storedAuth = localStorage.getItem("isAuth")||false;

  //   if (storedAuth) {
  //     setIsAuth(JSON.parse(storedAuth));
  //   }
  // }, []);

  // useEffect(() => {
  //   // Update localStorage when authentication state changes
  //   localStorage.setItem("isAuth", isAuth);
  // }, [isAuth]);
  useEffect(() => {
    localStorage.setItem("token", JSON.stringify(token));
  }, [token]);

  if (isAuth) {
    return <Navigate to={"/"} />;
  }
  // console.log(isAuth, msg);
  return (
    <form onSubmit={handleSubmit}>
      <Flex minH={"100vh"} align={"center"} justify={"center"}>
        {/* {isAuth ? <div>{msg}</div> : ""} */}
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"}>Login to your account</Heading>
            <Text fontSize={"lg"} color={"gray.600"}>
              to enjoy all of our cool features
            </Text>
          </Stack>
          <Box rounded={"lg"} boxShadow={"lg"} p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  align={"start"}
                  justify={"space-between"}
                >
                  {/* Updated checkbox handling */}
                  <Checkbox
                    isChecked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  >
                    Remember me
                  </Checkbox>
                  <Link color={"blue.400"}>Forgot password?</Link>
                </Stack>
                <Button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  bg={"blue.400"}
                  color={"white"}
                  _hover={{
                    bg: "blue.500",
                  }}
                >
                  Log-in
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </form>
  );
};

export default Login;

/*  <div>
      <h2>Login</h2>
      {isAuth ? <div>{msg}</div> : ""}
      <form onSubmit={handleSubmit}>
        <label>
          EMAIL:
          <br />
          <input
            type="text"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <br />
        <label>
          PASSWORD:
          <br />
          <input
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <br />
        <input type="submit" />
      </form>
    </div>*/
